import useIdleTimer from "../../hooks/useIdleTimer";

export const REFRESH_TIME_MS = 30 * 60 * 1000; // 30 minutes

export function useRefreshWhenStale() {
  useIdleTimer(REFRESH_TIME_MS, () => {
    window.location.reload();
  });
}
